//import required modules
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { WMSInput } from "../../widgets/input";
import { WMSSelect } from "../../widgets/selectbox";
import WHSLoader from "../../widgets/loader";
import { invokePostService } from "../../service";
import { apiUrl } from "../../base/utils";
import { connect } from "react-redux";
import { createColumnHelper } from "@tanstack/react-table";
import CustomTable from "../table/customTable";
import HOCAutoLogout from "../autologout";

const summarystatus = [
  { value: "all status", label: "All Status" },
  { value: "reviewing manuscript", label: "Reviewing Manuscript" },
  { value: "invitation declined", label: "Invitation Declined" },
  { value: "review completed", label: "Review Completed" },
  {
    value: "awaiting response from reviewer",
    label: "Awaiting Response From Reviewer",
  },
];

// Create column helper instance
const columnHelper = createColumnHelper();

// Table columns
const columns = [
  columnHelper.accessor("journalcode", {
    header: "Journal",
  }),
  columnHelper.accessor("articleid", {
    header: "Artical ID",
  }),
  columnHelper.accessor("name", {
    header: "Artical Name",
  }),
  columnHelper.accessor("invitationsent", {
    header: "Invitation Sent",
  }),
  columnHelper.accessor("revisioncount", {
    header: "Revision Count",
  }),

  columnHelper.accessor("status", {
    header: () => "Status",
    cell: (row) => {
      const value = row.getValue();
      let className = "cellStyle";
      let displayValue: string = value;

      // Setting className based on the value
      switch (value) {
        case "review completed":
          className += " greenbadge";
          break;
        case "awaiting response from reviewer":
          className += " yellowBadge";
          displayValue = "awaiting response";
          break;
        case "reviewing manuscript":
          className += " reviewingManuscript";
          break;
        case "invitation declined":
          className += " failed";
          displayValue = "invitation declined";
          break;

        default:
        // Incase if needed add class for default case
      }

      return <span className={className}>{displayValue}</span>;
    },
  }),
];
function SummaryDetails(props: any) {
  const location = useLocation();
  const userData = location.state && location.state.userData;
  const navigate = useNavigate();
  const [alluserData, setAllUserData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [statusOptions, setStatusOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [statusvalue, setStatusValue] = useState("");
  const [reviewCount, setReviewCount] = useState("");

  useEffect(() => {
    // fetchSummaryDetails();
    getTableData();
    getStatusOptions();
  }, []);

  // const fetchSummaryDetails = async () => {
  //     userData && setSummaryDetails(userData);
  // };
  const handleBack = () => {
    navigate("/usermanagement", { state: { userData: null } });
  };

  const getTableData = async () => {
    try {
      setIsLoader(true);
      let url = apiUrl.nodeApi.getdataByUserId;
      let payload = {
        userId: userData.userid,
      };
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      // response.data.data.result.map((item: any, i: any) => {

      // })
      let count: any = [];
      response.data.data.result.map((list: any) => {
        list.invitationsent = "yes";
        list.revisioncount = (list.revisioncount === null || 0) ? "First Review" : list.revisioncount === 1 ? "Revision 1" : "Revision 2";
        if ("review completed" === list.status.toLowerCase()) {
          count.push({ status: list.status });
        }
      });
      setReviewCount(count.length);
      setAllUserData(response.data.data.result);
      setInitialData(response.data.data.result);

      //need reviewed count from the response

      setIsLoader(false);
    } catch (e) {
      setIsLoader(false);
    }
  };

  const handleSearch = (e: any) => {
    //search journal id and article id in alluserData state
    let searchValue = e.target.value.toLowerCase();

    if (e.target.value.length === 0) {
      setAllUserData(initialData);
    } else {
      const filteredData = alluserData.filter((item: any) => {
        return ["journalcode", "name"].some((key) => {
          const value = item[key];
          if (value) {
            const valueString =
              typeof value === "number" ? value.toString() : value;
            return valueString.toLowerCase().includes(searchValue);
          }
          return false;
        });
      });
      setAllUserData(filteredData);
    }
  };

  //get status options
  const getStatusOptions = () => {
    let statusOptions: any = summarystatus.map((item: any) => {
      return { value: item.value, label: item.label };
    });
    setStatusOptions(statusOptions);
  };

  const handleFormSelection = (e: any) => {
    setStatusValue(e);
    let selectedValue = e.value;
    let filteredData = initialData.filter((item: any) => {
      if (selectedValue === "") {
        return item;
      } else if (selectedValue !== "all status") {
        return item.status.toLowerCase().includes(selectedValue.toLowerCase());
      } else {
        return item;
      }
    });
    setAllUserData(filteredData);
  };
  const refreshTable = () => {
    getTableData();
  };
  return (
    <>
      {isLoader && <WHSLoader></WHSLoader>}
      <div className="custom-style">
        <div>
          <div className="page-title">
            <div className="d-flex">
              <Button
                onClick={handleBack}
                className="iconBtn"
                title="Back"
                style={{ padding: "0px" }}
              >
                <span className="material-icons">chevron_left</span>
              </Button>
              <h3>Peer Review Summary</h3>
            </div>
          </div>
          <div className="table-filter">
            <div className="row justify-content-between">
              <div className="col-lg-4 search-input">
                <WMSInput
                  type="text"
                  placeHolder="Search by journal or article id.."
                  className="form-control"
                  id="search-table"
                  name="search-table"
                  onChange={(e: any) => handleSearch(e)}
                />
                <span className="material-icons">search</span>
              </div>

              <div className="d-flex col-lg-8 table-dropdown-filter">
                <div className="d-flex">
                  <label>Filter by</label>
                  <div className="table-dropdown-filter-inner">
                    <WMSSelect
                      className="form-control"
                      placeHolder={"All Status"}
                      options={statusOptions}
                      name="fileTypes"
                      value={statusvalue}
                      isMulti={false}
                      onChange={(e: any) => handleFormSelection(e)}
                      id="fileTypes"
                    />
                  </div>
                </div>
                <Button
                  onClick={() => refreshTable()}
                  className="btn btn-primary refresh-btn ml-2"
                >
                  <span className="material-icons">refresh</span>
                </Button>
              </div>
            </div>
          </div>
          <div className="mt-0 mb-2">
            <span className="fontchange">
              Peer Reviewer: <b>{userData.email}</b>
            </span>{" "}
            <br />
            <span className="fontchange">
              Total Articles Reviewed: {reviewCount}{" "}
            </span>
          </div>
        </div>
        <CustomTable
          columns={columns}
          data={alluserData}
          showPagination={true}
          isSearchable={false}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state: any) => {
  return {
    isLogged: state.rootReducer.authReducer.isLoggedIn,
    isToken: state.rootReducer.authReducer.token,
    userInfo: state.rootReducer.authReducer.userInfo,
  };
};

export default connect(mapStateToProps, null)(HOCAutoLogout(SummaryDetails));
